/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Tag, TagProps, mergeClasses} from "@microsoft/shifts-ui-core";
import * as React from "react";

import { useStyles } from "./TeamTag.styles";

/**
 * Renders the TeamTag component to display a team tag.
 * @param props The properties for the TeamTag component.
 * @returns The TeamTag component.
 */

export const TeamTag: React.FC<TagProps> = (props) => {
    const styles = useStyles();
    const { className: propsClassName, ...otherProps } = props;
    const className = propsClassName ? mergeClasses(styles.teamTag, propsClassName) : styles.teamTag;

    return (
        <Tag
            size="small"
            shape="circular"
            className={className}
            {...otherProps}
        />
    );
};
